import styled from 'styled-components'

export const WarningText = styled.span`
  min-height: auto;
  font-size: 0.75rem;
  /* This value was set to match the designs */
  letter-spacing: -0.2px;
`
